import { StyleSheet } from 'react-native'
import {
  corporateColor,
  titleCardsColor,
  toqueColor,
  white,
  whiteBackgroundColor,
} from '../../../theme/colors'
import { DOBRA, DOBRA_LIGTH } from '../../../theme/fonts'

export const styles = StyleSheet.create({
  container: {
    borderRadius: 20,
    padding: 42,
    paddingTop: 20,
    paddingBottom: 35,
    justifyContent: 'flex-start',
    height: '100%',
    backgroundColor: whiteBackgroundColor,
    paddingLeft: 15,
    paddingRight: 15,
  },

  containerBottom: {
    backgroundColor: white,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    padding: 50,
    position: 'absolute',
    bottom: 0,
  },
  containerMic: {
    width: 80,
    borderRadius: 40,
    height: 80,
    zIndex: 100,
    position: 'absolute',
    backgroundColor: white,
  },
  microphone: {
    width: 80,
    borderRadius: 1000,
    height: 80,
    zIndex: 100,
    position: 'absolute',
    backgroundColor: toqueColor,
  },

  circleStop: {
    width: 55,
    borderRadius: 1000,
    height: 55,
    zIndex: 100,
    position: 'absolute',
    backgroundColor: white,
  },

  helpTextsPrimary: {
    fontSize: 22,
    fontFamily: DOBRA,
    color: titleCardsColor,
    textAlign: 'center',
    marginBottom: 90,
  },

  helpTextsSecondary: {
    fontSize: 17,
    textAlign: 'center',
    color: corporateColor,
    marginBottom: 0,
    fontFamily: DOBRA_LIGTH,
  },
})
